import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "98",
  height: "98",
  viewBox: "0 0 98 98",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "49",
  cy: "49",
  r: "49",
  fill: "#5061FA"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M22.1875 46.0209L40.0623 30.0137H57.937H75.8118V46.0209H57.937H40.0623H22.1875ZM40.0623 51.9792H22.1875V59.9828C22.1875 64.4031 25.7708 67.9865 30.1911 67.9865H40.0623H57.937L75.8118 51.9792H57.937H40.0623Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}